import store from '@/store';
import app from '../main';

store.watch(
    (state) => state.loader.loading,
    (newVal, oldVal) => {
      if (newVal === 0) return app.$Progress.finish();
      if (oldVal === 0) return app.$Progress.start();
      app.$Progress.set(1.8 / Math.max(oldVal, newVal));

      console.log('new '+newVal + ' - old ' +oldVal)
    },
  );